









































































































































import {Vue,Prop,Component} from 'vue-property-decorator';
import TriStateCheckbox from '@/components/UiComponents/TriStateCheckBox.vue';
import PrioritySelector from '@/components/Cartable/FastSend/PrioritySelector/PrioritySelector.vue';
import LetterOwnerLookup from './LetterOwnerLookup/LetterOwnerLookup.vue';
import * as letterOwnerService from '@/store/Services/letterOwnerService';
import * as letterService from '@/store/Services/letterServices';
import { LetterOwner } from '@/store/models/LetterOwner/LetterOwner';
import { EnterpriseForm } from '@/store/models/EnterpriseForm/EnterpriseForm';
import store from '@/store';
import * as enterpriseFromService from '@/store/Services/enterpriseFormService.ts';

import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import letterSearch from '@/store/models/Letter/letterSearch';
import persianDate from 'persian-date';
import * as $ from 'jquery';

@Component({
        components: {TriStateCheckbox, PrioritySelector, LetterOwnerLookup, VuePersianDatetimePicker}
})
export default class AdvancedSerach extends Vue
{       
        enterpriseForms = [] as EnterpriseForm[];
        allLetterOwners = [] as LetterOwner[];
        canSeeAllLetters = false;
        cartableOwnerId = ''; 
        isFirstClickDone = false;
        shallShowList = false;
        dateFrom = '';
        dateTo = '';
        responseDateFrom = '';
        responseDateTo = '';
        isFinalized = 'dontCare';
        isSecret = 'dontCare';
        isReturned = 'dontCare';
        presentInId = '';
        fromOwnerId = '';
        toOwnerId = '';
        ownerId = '';
        isLoading = false;
        title = '';
        enterpriseFormId = '';
        abstract = '';
        letterNo = '';
        senderLetterNo = '';
        forwardComment = '';
        finalizeComment = '';
        formSearchTxt = '';

        async created(){
               this.allLetterOwners = await letterOwnerService.getAllLetterOwners(); 
               this.canSeeAllLetters = store.state.canSeeAllLetters;
               while(this.cartableOwnerId === ''){
                       this.cartableOwnerId = store.state.ownerId;
               }
                store.state.eventHub.$on('update-enterpriseForms',this.changeOwnerId)
        }

        showDropDown(){
                 $('#enterpriseForm-dropdown').dropdown( 'show'                       
                );
        }

        async changeOwnerId(ownerId: string){
                this.ownerId=ownerId;
                this.cartableOwnerId = ownerId;
                this.loadEnterpriseForms(this.ownerId);
        }
        selectItem(form: any){
                this.formSearchTxt=form.name;
                this.enterpriseFormId=form.id;
                this.shallShowList=false;
        }

        get filteredForms(){
        return this.enterpriseForms.filter(x=>x.name.includes(this.formSearchTxt));
        }

        mounted(){
                $('#enterpriseForm-dropdown').dropdown(
                        {action:'hide',
                        silent: true,
                        duration:300,
                        }
                );
        }
        onLetterOwnerSelected(ownerId: string, mode: string){
                if(mode === 'cartable'){
                        this.cartableOwnerId = ownerId;
                }
                else if(mode === 'present')
                        this.presentInId = ownerId;
                else if(mode === 'from')
                        this.fromOwnerId = ownerId;
                else if(mode === 'to')
                        this.toOwnerId = ownerId;

                
        }
        onSateChanged(state: string, mode: string){
                if(mode === 'finalized')
                        this.isFinalized = state;
                if(mode === 'secret')
                        this.isSecret = state;
                if(mode === 'returned')
                        this.isReturned = state;
                
        }

        clear(){
                
                this.isFinalized = 'dontCare';
                this.isSecret = 'dontCare';
                this.isReturned = 'dontCare';
                this.presentInId = '';
                this.fromOwnerId = '';
                this.toOwnerId = '';
                this.dateFrom = '';
                this.dateTo = '';
                this.responseDateFrom = '';
                this.responseDateTo = '';
                this.title = '';
                this.abstract = '';
                this.letterNo = '';
                this.senderLetterNo = '';
                this.forwardComment = '';
                this.finalizeComment = '';
                (this.$refs.prioSelector as any).clear();

        }
        async loadEnterpriseForms(ownerId: string){
                        this.isLoading = true;
                        this.enterpriseForms =  await enterpriseFromService.getOwnerEnterpriseForms(ownerId);
                        this.enterpriseForms = this.enterpriseForms.sort((x,y)=> y.selectionColor - x.selectionColor);
                        this.isLoading = false;
        }
        // setForm(id: string){

        // }
        onShowEnterpriseForm(){
                this.shallShowList=true;
                this.ownerId =  store.state.ownerId;
                // if(this.isFirstClickDone || this.ownerId === '')return
                // this.isFirstClickDone = true;
                this.loadEnterpriseForms(this.ownerId);        
        }
        async doSearch(){
                const searchDto = {} as letterSearch ;
                if(this.enterpriseFormId !=='')searchDto.EnterpriseForm = this.enterpriseFormId;
                if(this.title !=='')searchDto.title = this.title;
                if(this.formSearchTxt !=='')searchDto.enterpriseFormName = this.formSearchTxt;
                if(this.abstract !=='') searchDto.abstract = this.abstract;
                if(this.letterNo !=='') searchDto.letterNumberSequence = this.letterNo;
                if(this.senderLetterNo !== '') searchDto.IncomingLetterNumberReferenceNumber = this.senderLetterNo;
                if(this.forwardComment !== '') searchDto.comment = this.forwardComment;
                if(this.finalizeComment !== '') searchDto.closingComment = this.finalizeComment;
                searchDto.SearchingOwner = {} as LetterOwner;
                searchDto.SearchingOwner.id = store.state.ownerId;
                searchDto.searchInLetterOwnerDashboard = {} as LetterOwner;
                searchDto.searchInLetterOwnerDashboard.id = this.cartableOwnerId;
                
                if(this.toOwnerId !== '')
                {
                        searchDto.sendTo = {} as LetterOwner;
                        searchDto.sendTo.id = this.toOwnerId;
                }
                if(this.fromOwnerId !==''){
                        searchDto.sendFrom = {} as LetterOwner;
                        searchDto.sendFrom.id = this.fromOwnerId;
                }
                if(this.presentInId != ''){
                        searchDto.OwnerParticipateInTrail = {} as LetterOwner;
                        searchDto.OwnerParticipateInTrail.id = this.presentInId;
                }
                if(this.isFinalized === 'checked' || this.isFinalized === 'unChecked')
                        searchDto.isClosed = this.isFinalized === 'checked';
                if(this.isReturned === 'checked' || this.isReturned === 'unChecked')
                        searchDto.SearchInReturnedLetters = this.isReturned === 'checked';
                if(this.isSecret === 'checked' || this.isSecret === 'unChecked')
                        searchDto.isSecured = this.isSecret === 'checked';
                if(this.dateFrom !== '')
                        searchDto.sentTimeFrom = this.getDateFrom(this.dateFrom);
                if(this.dateTo !== '')
                        searchDto.sentTimeTo = this.getDateTo(this.dateTo);
                if(this.responseDateFrom !== '')
                        searchDto.answerTimeFrom = this.getDateFrom(this.responseDateFrom);
                if(this.responseDateTo !== '')
                        searchDto.answerTimeTo = this.getDateTo(this.responseDateTo);
                searchDto.isConjunctive = true;
                if(this.priority){
                        searchDto.priorityFrom = this.priority;
                        searchDto.priorityTo = this.priority;
                }
                store.commit("setAdvancedSearchSettings",searchDto);
                this.$router.push({name: "SearchResults"}).catch(err=>{ console.log('')});
             
        }

        getDateFrom(dateStr: string){
                try {
                        const splited = dateStr.split('/');
                        const datePersian = new persianDate([parseInt(splited[0]),parseInt(splited[1]),parseInt(splited[2])]);
                        return datePersian.toDate();
                
                } catch (error) {
                        return null;       
                }
        }

        getDateTo(dateStr: string){
                try {
                        const splited = dateStr.split('/');
                        const datePersian = new persianDate([parseInt(splited[0]),parseInt(splited[1]),parseInt(splited[2]),23,59,59]);
                        return datePersian.toDate();
                
                } catch (error) {
                        return null;
                }
        }
        priority?: number = undefined;
        onPriorityChanged(priority: any){
                if(priority){
                        if(priority === 'low')this.priority = 1;
                        if(priority === 'med')this.priority = 5;
                        if(priority === 'high')this.priority = 10;
                }
                else
                        this.priority = undefined;
        }

}
